import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type AuthorFragment = {
	__typename?: 'Author';
	id: string;
	content: {
		__typename?: 'AuthorContent';
		clearName: string;
		imageUrl?: string | null;
		fullPath: string;
		bio?: string;
		alumniOf?: Array<string>;
		brand?: string;
		languagesSpoken?: Array<any>;
		occupation?: Array<string>;
		publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
		socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
	};
};

export const AuthorFragmentDoc = gql`
	fragment Author on Author {
		id
		content(country: $country, language: $language) {
			clearName
			imageUrl @include(if: $authorImage)
			fullPath
			bio @skip(if: $authorPreview)
			alumniOf @skip(if: $authorPreview)
			brand @skip(if: $authorPreview)
			languagesSpoken @skip(if: $authorPreview)
			occupation @skip(if: $authorPreview)
			publications @skip(if: $authorPreview) {
				name
				url
			}
			socialHandles @skip(if: $authorPreview) {
				name
				url
			}
		}
	}
`;
